import { render, staticRenderFns } from "./SubmitFooter.vue?vue&type=template&id=7dc7d942"
import script from "./SubmitFooter.vue?vue&type=script&lang=js"
export * from "./SubmitFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports